import {Component, Input, OnInit} from '@angular/core';
import {MeasurementSlotListComponent} from "../measurementslot-list/measurement-slot-list.component";
import {ThemePalette} from "@angular/material/core";
import {ProgressSpinnerMode} from "@angular/material/progress-spinner";
import {MeasurementDescription} from "../../measurements/MeasurementDescriptionList";
import {MeasurementData} from "../../measurements/MeasurementDataList";
import {isDefined} from "@angular/compiler/src/util";
import {sprintf} from "sprintf-js";

@Component({
  selector: 'app-measurement-details',
  templateUrl: './measurement-slot-details.component.html',
  styleUrls: ['./measurement-slot-details.component.css']
})
export class MeasurementSlotDetailsComponent implements OnInit {
  @Input()
  slotNumber: number = -1;

  measurementData: MeasurementData;
  measurementDescription: MeasurementDescription;
  oldStyleChannel: string = "";
  status: string = "";

   constructor(private measurementListComponent: MeasurementSlotListComponent) {
     this.measurementData = new MeasurementData();
     this.measurementDescription = new MeasurementDescription();
     measurementListComponent.Add(this);
   }

  UpdateDescription(measurementDescription: MeasurementDescription): void
  {
     this.measurementDescription = measurementDescription;
     let channelNr: number = Math.floor( this.measurementDescription.channelfull / 2 ) + 1;
     let channelA: string = ((Math.floor( this.measurementDescription.channelfull) % 2)==1) ? "A" : "-"
     this.oldStyleChannel = channelNr + channelA;
  }


   GetFullChannel(): number
   {
     return this.measurementData.channelfull;
   }



  UpdateData(measurementData: MeasurementData): void
  {
    this.measurementData = measurementData;
    this.status = String.fromCharCode(this.measurementData.status);
  }

  GetDepartment()  : string
  {
    if(this.measurementDescription.department.length > 4)
      return this.measurementDescription.department;
    return this.measurementData.department_name;
  }


  GetDescription() : string
  {
    if(this.measurementDescription.description.length > 4)
      return this.measurementDescription.description;
    return this.measurementData.description;
  }

  GetValue():string
  {
      switch(this.measurementData.measurementprecision) {
        case 4:
          return sprintf("%6.4f", this.measurementData.measurementvalue / 10000);
        case 3:
          return sprintf("%7.3f", this.measurementData.measurementvalue / 1000);
        case 2:
          return sprintf("%8.2f", this.measurementData.measurementvalue / 100);
        case 1:
          return sprintf("%9.1f", this.measurementData.measurementvalue / 10);

        case 0:
          return sprintf("%10f", this.measurementData.measurementvalue);
        default:
          return sprintf("%f (Wrong precision)", this.measurementData.measurementvalue);

      }

    // return Number(120 / (10)).toString(10);
    // if(this.measurementData)
    //     return Number(this.measurementData.measurementvalue / (1 << this.measurementData.measurementprecision)).toString();
    // else
    //   return "123.4";

      //,this.measurementData.format);


  }

  ngOnInit(): void
  {
  }

}
